import { Box } from '@mui/material';
import React from 'react';

/**
 * Reusable box component with green corner accents (non-card version)
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Box content
 * @param {Object} props.sx - Additional MUI sx styling
 * @param {string} props.maxWidth - Maximum width of the box
 * @returns {JSX.Element} Green corner box component
 */
function GreenCornerBox({ children, sx = {}, maxWidth = '800px', ...props }) {
  return (
    <Box
      sx={{
        backgroundColor: 'var(--color-card)',
        p: 3,
        maxWidth,
        mx: 'auto',
        position: 'relative',
        border: '1px solid var(--color-border)',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: -1,
          left: -1,
          width: '40px',
          height: '40px',
          borderTop: '3px solid var(--color-primary)',
          borderLeft: '3px solid var(--color-primary)',
          borderRadius: '0 !important',
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: -1,
          right: -1,
          width: '40px',
          height: '40px',
          borderBottom: '3px solid var(--color-primary)',
          borderRight: '3px solid var(--color-primary)',
          borderRadius: '0 !important',
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
}

export default GreenCornerBox;
